module.exports = __webpack_public_path__ + "static/media/accept-rules-header-light.0361499f.png";